<template>
  <div class="page">
  <div id="canvasBox"></div>
    <div class="left-container">
      <div class="contentWrap">
        <div class="title"> 运营人数据</div>
        <div id="leftTopChart" class="chartWrap">
        </div>
      </div>
      <div class="contentWrap">
        <div class="title">运营人统计排名</div>
        <div class="operatorRankWrap">

          <el-carousel :interval="5000" arrow="always">
          <el-carousel-item   v-for="(item,index) in leftMiddleData" :key="index">
          <div class="operatorRankItem" v-for="(v,i) in item" :key="i">
            <div class="bottomName ">{{v[0]}}</div>
            <div class="progressBar">
              <el-progress :percentage="v[2]" :show-text="false" :text-inside="true" :color="index ===0?i===0?'#ff8c4d':i===1?'#ff5555':i===2?'#5591ff':'#ffc877':'#ffc877'"></el-progress>
            </div>
            <div class="figure">{{v[1]}}</div>
          </div>
          </el-carousel-item>
          </el-carousel>

        </div>
      </div>
      <div class="contentWrap">
        <div class="title">飞行器统计排名</div>

        <div class="rankWrap" >
          <el-carousel :interval="5000" arrow="always">
            <el-carousel-item   v-for="(item,index) in leftBottomData" :key="index">
          <div class="rankItem" v-for="(v,i) in item" :key="i">
            <div class="bottomName " :class="index ===0?i===0?'firstName':i===1?'secondName':i===2?'thirdName':'otherName':'otherName'">{{v[0]}}</div>
            <div class="progressBar">
              <el-progress :percentage="v[2]" :show-text="false" :text-inside="true" :color="index ===0?i===0?'#ff8c4d':i===1?'#ff5555':i===2?'#5591ff':'#ffc877':'#ffc877'"></el-progress>
            </div>
            <div class="figure">{{v[1]}}</div>
          </div>
            </el-carousel-item>
          </el-carousel>
        </div>

      </div>
    </div>
    <div class="middle-container">
        <div class="middleTop">
          <div class="middleTopItem heifei">
            <div class="itemContent">
                  <span class="itemTitle">黑飞</span>
                  <span class="itemValue">{{ flyStatus[0] ? flyStatus[0] : '暂无' }}</span>
            </div>
          </div>
          <div class="middleTopItem  chongtu">
            <div class="itemContent">
                <span class="itemTitle">冲突</span>
                <span class="itemValue">{{ flyStatus[1] ? flyStatus[1] : '暂无' }}</span>
            </div>
          </div>
          <div class="middleTopItem pianhang">
            <div class="itemContent">
                <span class="itemTitle">偏航</span>
                <span class="itemValue">{{ flyStatus[2] ? flyStatus[2] : '暂无' }}</span>
            </div>
          </div>
          <div class="middleTopItem zhengchang">
            <div class="itemContent">
                <span class="itemTitle">正常</span>
                <span class="itemValue">{{ flyStatus[3] ? flyStatus[3] : '暂无' }}</span>
            </div>
          </div>
        </div>
        <div id="middleChart" ref="mapContainer" class="middleChart">
        </div>
        <div class="middleBottom">
          <div  class="bottomItem">
            <div class="bottomItemContent">
                <span class="value">{{filterPlanData('正在飞行')}}</span>
                <span class="key">正在飞行</span>
            </div>
            <svgaplayer :src="'/static/svga/orange.svga'"
            :styleObj="{ height: '250px',width:'250px '}"
            ></svgaplayer>
          </div>
          <div  class="bottomItem">
            <div class="bottomItemContent">
              <span class="value">{{filterPlanData('待执行')}}</span>
              <span class="key">待执行</span>
            </div>
            <svgaplayer :src="'/static/svga/gold.svga'"
                        :styleObj="{ height: '250px',width:'250px '}"
            ></svgaplayer>
          </div>
          <div  class="bottomItem">
            <div class="bottomItemContent">
              <span class="value">{{filterPlanData('已驳回')}}</span>
              <span class="key">已驳回</span>
            </div>
            <svgaplayer :src="'/static/svga/orange.svga'"
                        :styleObj="{height: '250px',width:'250px '}"
            ></svgaplayer>
          </div>
          <div class="bottomItem">
            <div class="bottomItemContent">
              <span class="value">{{filterPlanData('已完成')}}</span>
              <span class="key">已完成</span>
            </div>
            <svgaplayer :src="'/static/svga/gold.svga'"
                        :styleObj="{height: '250px',width:'250px '}"
            ></svgaplayer>
          </div>
        </div>
    </div>

    <div class="right-container">
      <div class="contentWrap">
        <div class="title"> 飞手数据</div>
        <div id="rightTopChart" class="chartWrap"></div>
      </div>
      <div class="contentWrap">
        <div class="title">飞行统计</div>
        <div id="rightMiddleChart" class="chartWrap"></div>
      </div>
      <div class="contentWrap ">
        <div class="title">飞手统计排名</div>
        <div class="rankWrap" >
          <el-carousel  direction="vertical"  :interval="5000" arrow="always"  >
            <el-carousel-item v-for="(item,index) in rightBottomData" :key="index">
              <div class="rankItem" v-for="(v,i) in item" :key="i">
                <div class="bottomName " :class="index ===0?i===0?'firstName':i===1?'secondName':i===2?'thirdName':'otherName':'otherName'">{{v[0]}}</div>
                <div class="progressBar">
                  <el-progress :percentage="v[2]" :show-text="false" :text-inside="true" :color="index ===0?i===0?'#ff8c4d':i===1?'#ff5555':i===2?'#5591ff':'#ffc877':'#ffc877'"></el-progress>
                </div>
                <div class="figure">{{ v[1] }}</div>
              </div>
            </el-carousel-item>
          </el-carousel>

        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import echarts from 'echarts';
import svgaplayer from "../tools/svgaplayer.vue";
import SVGA from 'svgaplayerweb';
import * as THREE from 'three';
import { OrbitControls } from "../../../node_modules/three/examples/jsm/controls/OrbitControls.js"
import { TextGeometry } from '../../../node_modules/three/examples/jsm/geometries/TextGeometry.js';
import { FontLoader } from '../../../node_modules/three/examples/jsm/loaders/FontLoader.js';
import * as d3 from 'd3';
import jsondata from '../../assets/provinceJson/fujian.json'


export default {
  components: {
    svgaplayer,
  },
  name: "FlightStatistics",
  data() {
    return {
      flyStatus:[1,2,2,32],
      contant:null,
      raycaster:null,
      lastClickedObject:null,//点击的省份
      map:null,//地图对象
      camera:null,//地图相机
      provinceMeshData:[], //省份材质数组
      particles:[], //粒子数组


      leftTopData:{xAxis:[],AlarmyAxis:[],completeyAxis:[]},
      leftMiddleData:[],
      leftBottomData:[],

      rightTopData:{xAxis:[],AlarmyAxis:[],completeyAxis:[]},
      rightMiddleData:[],
      rightBottomData:[],
      planData:[],
    }
  },
  created() {
  },
  async mounted() {
    await this.getPageData()
    this.initThree()
    window.addEventListener('resize', this.handleResize, {passive: true});
  },
  beforeDestroy() {
    this.disposeScene()
    window.removeEventListener('resize', this.handleResize);

  },
  methods: {
    initThree(){
      // 第一步新建一个场景
      this.scene = new THREE.Scene()
      this.contant = document.getElementById('middleChart')
      // 辅助线
      // const axesHelper = new THREE.AxesHelper(10);
      // this.scene.add(axesHelper);
      // 光源
      this.spotLight = new THREE.PointLight('#fff', 1.5, 100)
      this.spotLight.position.set(0, 0, 1)
      this.scene.add(this.spotLight)
      //环境光
      const ambient = new THREE.AmbientLight('#fff', 0.5)
      this.scene.add(ambient)
      // 可视化点光源
      // const pointLightHelper = new THREE.PointLightHelper(this.spotLight, 0.1)
      // this.scene.add(pointLightHelper)
      this.setCamera()
      this.setRenderer()
      this.generateGeometry()
      this.setClickFn()
      // this.createCylindern()
      this.animate()
      this.setController()
      // 鼠标移动事件处理
      this.contant.addEventListener('mousemove', (event) => {
        const raycaster = new THREE.Raycaster();
        const mouse = new THREE.Vector2();
        // 计算鼠标位置
        const rect = this.contant.getBoundingClientRect();
        mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        // 发射射线
        raycaster.setFromCamera(mouse, this.camera);
        const intersects = raycaster.intersectObjects(this.provinceMeshData, true); // 假设 cities 是你的城市 Mesh 数组
        if (intersects.length > 0) {
          // 如果有交集，设置光标为手指
          this.contant.style.cursor = 'pointer';
        } else {
          // 否则恢复为默认光标
          this.contant.style.cursor = 'auto';
        }
      });
      window.onresize = () => {
        this.renderer.setSize(this.contant.clientWidth, this.contant.clientHeight);
        this.camera.aspect = this.contant.clientWidth / this.contant.clientHeight;
        this.camera.updateProjectionMatrix();
      };
    },
   async getPageData(){
     await Promise.all([
       this.getAlarmStatistics(),
       this.getFlightStatistics(),
       this.getAlarmOperatorAlarm(),
       this.getAlarmOperatorCompletion(),
       this.getAlarmOperatorRank(),
       this.getAlarmPilotAlarm(),
       this.getAlarmPilotCompletion(),
       this.getAlarmPilotRank(),
       this.getAlarmPlanStatistics(),
       this.getAlarmUavRank()
     ]);
     this.initCharts()
    },
    //告警统计
    getAlarmStatistics(){
      return new Promise((resolve, reject) => {
        this.getRequest("/uav-task-server/statistics/planStatistics").then(res => {
          let oData = res.data;
          if (oData.code === 0) {
            resolve()
          }
        });
      });
    },
    //飞行统计
    getFlightStatistics(){
      return new Promise((resolve, reject) => {
        this.getRequest("/uav-task-server/statistics/flightStatistics").then(res => {
          let oData = res.data;
          if (oData.code === 0) {
            this.rightMiddleData = oData.data.xaxis.data.map((x, index) => [x, oData.data.series.data[index]])
            resolve()
          }
        });
      });

    },
    //运营人告警
    getAlarmOperatorAlarm(){
      return new Promise((resolve, reject) => {
        this.getRequest("/uav-task-server/statistics/operatorAlarm").then(res => {
          let oData = res.data;
          if (oData.code === 0) {
            this.leftTopData.xAxis = oData.data.xaxis.data
            this.leftTopData.AlarmyAxis = oData.data.series.data
            // let values = oData.data.series;
            resolve()
          }
        });
      });

    },
    //运营人完成率
    getAlarmOperatorCompletion(){
      return new Promise((resolve, reject) => {
        this.getRequest("/uav-task-server/statistics/operatorCompletion").then(res => {
          let oData = res.data;
          if (oData.code === 0) {
            this.leftTopData.completeyAxis = oData.data.series.data
            resolve()
          }
        });
      });

    },
    //运营人排名
    getAlarmOperatorRank(){
      return new Promise((resolve, reject) => {
        this.getRequest("/uav-task-server/statistics/operatorRank").then(res => {
          let oData = res.data;
          if (oData.code === 0) {
            // let temp = oData.data.xaxis.data.map((x, index) =>[x, parseInt(oData.data.series.data[index]),parseInt(oData.data.seriersPer.data[index])] )
            // let temp = [...oData.data.xaxis.data.map((x, index) =>[x, parseInt(oData.data.series.data[index]),parseInt(oData.data.seriersPer.data[index])] ),['华飞',6,21],['长江汇',6,21],['峰飞',5,18],['通号长沙',3,12],['臻诚',3,12],['南安交通',1,6],['亿兴电力',1,6]]
            let temp = [...oData.data.xaxis.data.map((x, index) =>[x, parseInt(oData.data.series.data[index]),parseInt(oData.data.seriersPer.data[index])] ),['华飞',6,21],['长江汇',6,21],['峰飞',5,18],['通号长沙',3,12],['臻诚',3,12],['南安交通',1,6],['亿兴电力',1,6]]
            for (let i = 0; i < temp.length; i += 5) {
              this.leftMiddleData.push(temp.slice(i, i + 5));
            }
            resolve()
          }
        });
      });

    },
    //飞手告警
    getAlarmPilotAlarm(){
      return new Promise((resolve, reject) => {
        this.getRequest("/uav-task-server/statistics/pilotAlarm").then(res => {
          let oData = res.data;
          if (oData.code === 0) {
            this.rightTopData.AlarmyAxis = oData.data.series.data
            resolve()
          }
        });
      });

    },
    //飞手完成率
    getAlarmPilotCompletion(){
      return new Promise((resolve, reject) => {
        this.getRequest("/uav-task-server/statistics/pilotCompletion").then(res => {
          let oData = res.data;
          if (oData.code === 0) {
            this.rightTopData.xAxis = oData.data.xaxis.data
            this.rightTopData.completeyAxis = oData.data.series.data
            resolve()
          }
        });
      });

    },
    //飞手排名
    getAlarmPilotRank(){
      return new Promise((resolve, reject) => {
        this.getRequest("/uav-task-server/statistics/pilotRank").then(res => {
          let oData = res.data;
          if (oData.code === 0) {
            // let temp = oData.data.xaxis.data.map((x, index) =>[x, parseInt(oData.data.series.data[index]),parseInt(oData.data.seriersPer.data[index])] )
            let temp = [...oData.data.xaxis.data.map((x, index) =>[x, parseInt(oData.data.series.data[index]),parseInt(oData.data.seriersPer.data[index])] ),['郑宗权',3,25],['陈斯福',3,25],['张佳鑫',3,25],['蓝政金',2,18],['侯登辉',1,12],['杨钰',1,12]]
            for (let i = 0; i < temp.length; i += 5) {
              this.rightBottomData.push(temp.slice(i, i + 5));
            }
            resolve()
          }
        });
      });

    },
    //飞行计划统计
    getAlarmPlanStatistics(){
      return new Promise((resolve, reject) => {
        this.getRequest("/uav-task-server/statistics/planStatistics").then(res => {
          let oData = res.data;
          if (oData.code === 0) {
            this.planData = oData.data.xaxis.data.map((x, index) => [x, oData.data.series.data[index]])
            resolve()
          }
        });
      });

    },
    //飞行器统计排名
    getAlarmUavRank(){
      return new Promise((resolve, reject) => {
        this.getRequest("/uav-task-server/statistics/uavRank").then(res => {
          let oData = res.data;
          if (oData.code === 0) {
            // let temp = oData.data.xaxis.data.map((x, index) =>[x, parseInt(oData.data.series.data[index]),parseInt(oData.data.seriersPer.data[index])] )
            let temp = [...oData.data.xaxis.data.map((x, index) =>[x, parseInt(oData.data.series.data[index]),parseInt(oData.data.seriersPer.data[index])] ),['FC30',3,15],['AFV',3,15],['Q20',2,12],['自动驾驶',2,12],['M3T',1,8],['4GCC',1,8]]
            for (let i = 0; i < temp.length; i += 5) {
              this.leftBottomData.push(temp.slice(i, i + 5));
            }
            resolve()
          }
        });
      });
    },
    initCharts() {
      // 初始化左边栏图表
      this.leftTop = echarts.init(document.getElementById('leftTopChart'));
      this.rightTop = echarts.init(document.getElementById('rightTopChart'));
      this.rightMiddle = echarts.init(document.getElementById('rightMiddleChart'));

      this.drawCharts();
    },
    setChartOptions(chart, options) {
      chart.setOption(options);
    },
    drawCharts() {
      // 绘制左边栏图表
      this.setChartOptions(this.leftTop, this.getOperatorAlarmRankingOptions());
      this.setChartOptions(this.rightTop, this.getPilotAlarmRankingOptions());
      this.setChartOptions(this.rightMiddle, this.geFlightStatisticsOptions());
    },
    getOperatorAlarmRankingOptions() {
      return {
        // 运营人告警排名图表配置
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          icon: 'circle',
          data: ['运营人计划完成率'],
          // data: ['运营人告警排名', '运营人计划完成率'],
          textStyle: {
            color: '#ececec' // 图例文字颜色
          },
          formatter: function (name) {
            return [`${name}`].join(''); // 使用圆形和名称
          },
          itemGap: 15 // 项目间距
        },
        grid: {
          left: 20,   // 左侧边距
          right: 20,  // 右侧边距
          top: 40,    // 顶部边距
          bottom: 10, // 底部边距
          containLabel: true // 是否包含坐标轴标签
        },
        xAxis: {
          type: 'category',
          data: this.leftTopData.xAxis
        },
        yAxis: [
          // {
          //   type: 'value',
          //   name: '(次)',
          //   splitLine: {
          //     show: true,
          //     lineStyle: {
          //       color: 'rgba(214, 214, 214, 0.3)' // 左侧 Y 轴横向栅格颜色，透明度为 0.3
          //     }
          //   },
          //   axisLine: {
          //     lineStyle: {
          //       color: '#ececec' // X 轴线颜色
          //     },
          //     show: false // 隐藏右侧 Y 轴的竖线
          //   },
          //   axisLabel: {
          //     color: '#ececec', // Y 轴文字颜色
          //   },
          // },
          {
            type: 'value',
            name: '(%)',
            // nameLocation: 'end', // Y 轴名称位置
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(214, 214, 214, 0.3)' // 右侧 Y 轴横向栅格颜色，透明度为 0.3
              }
            },
            axisLine: {
              show: false // 隐藏右侧 Y 轴的竖线
            },
            axisLabel: {
              color: '#ececec', // Y 轴文字颜色
            },
          },
        ],
        series: [
          // {
          //   name: '运营人告警排名',
          //   type: 'bar',
          //   data: this.leftTopData.AlarmyAxis,
          //   itemStyle: {
          //     color: '#ffc877',
          //     barBorderRadius: [10, 10, 0, 0],
          //   },
          //   barWidth: '20%',
          //   yAxisIndex: 0 // 指定使用左侧 Y 轴
          // },
          {
            name: '运营人计划完成率',
            type: 'bar',
            data: this.leftTopData.completeyAxis,
            itemStyle: {
              color: '#ff8c4d',
              barBorderRadius: [10, 10, 0, 0],
            },
            barWidth: '16',
            // yAxisIndex: 1 // 指定使用右侧 Y 轴
            yAxisIndex: 0
          }
        ],
        textStyle: {
          color: '#ececec' // 全局文字颜色
        }
      };
    },
    getPilotAlarmRankingOptions() {
      return {
        // 飞手告警排名图表配置
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          icon: 'circle',
          // data: ['飞手告警排名', '飞手计划完成率'],
          data: ['飞手计划完成率'],
          textStyle: {
            color: '#ececec' // 图例文字颜色
          },
          formatter: function (name) {
            return [`${name}`].join(''); // 使用圆形和名称
          },
          itemGap: 15 // 项目间距
        },
        grid: {
          left: 20,   // 左侧边距
          right: 20,  // 右侧边距
          top: 40,    // 顶部边距
          bottom: 10, // 底部边距
          containLabel: true // 是否包含坐标轴标签
        },
        xAxis: {
          type: 'category',
          data: this.rightTopData.xAxis
        },
        yAxis: [
          // {
          //   type: 'value',
          //   name: '(次)',
          //   splitLine: {
          //     show: true,
          //     lineStyle: {
          //       color: 'rgba(214, 214, 214, 0.3)' // 左侧 Y 轴横向栅格颜色，透明度为 0.3
          //     }
          //   },
          //   axisLine: {
          //     lineStyle: {
          //       color: '#ececec' // X 轴线颜色
          //     },
          //     show: false // 隐藏右侧 Y 轴的竖线
          //   },
          //   axisLabel: {
          //     color: '#ececec', // Y 轴文字颜色
          //   },
          // },
          {
            type: 'value',
            name: '(%)',
            // nameLocation: 'end', // Y 轴名称位置
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(214, 214, 214, 0.3)' // 右侧 Y 轴横向栅格颜色，透明度为 0.3
              }
            },
            axisLine: {
              show: false // 隐藏右侧 Y 轴的竖线
            },
            axisLabel: {
              color: '#ececec', // Y 轴文字颜色
            },
          },
        ],
        series: [
          // {
          //   name: '飞手告警排名',
          //   type: 'bar',
          //   data: this.rightTopData.AlarmyAxis,
          //   itemStyle: {
          //     color: '#ffc877',
          //     barBorderRadius: [10, 10, 0, 0],
          //   },
          //   barWidth: '20%',
          //   yAxisIndex: 0 // 指定使用左侧 Y 轴
          // },
          {
            name: '飞手计划完成率',
            type: 'bar',
            data: this.rightTopData.completeyAxis,
            itemStyle: {
              color: '#ff8c4d',
              barBorderRadius: [10, 10, 0, 0],
            },
            barWidth: '16',
            // yAxisIndex: 1 // 指定使用右侧 Y 轴
            yAxisIndex: 0
          }
        ],
        textStyle: {
          color: '#ececec' // 全局文字颜色
        }
      };
    },
    geFlightStatisticsOptions() {
      return {
        tooltip: {
          trigger: 'axis', // 鼠标悬停时触发
          formatter: function (params) {
            let result = `<strong>${params[0].name}</strong><br/>`; // 显示时间
            params.forEach(item => {
              result += `飞行次数: ${item.value[1]}次<br/>`; // 显示数据
            });
            return result;
          },
          backgroundColor: '#fff',
          borderColor: '#ccc',
          borderWidth: 1,
          padding: 10,
          textStyle: {
            color: '#333',
            fontSize: 14
          }
        },
        grid: {
          top: 30,
          left: 30,
          right: 30,
          bottom: 30,
          width: 'auto',
          height: 'auto',
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)', // 坐标轴颜色
            }
          },
          axisLabel: {
            color: '#fff', // 坐标字体颜色
          },
          axisTick: {
            show: false, // 去掉轴刻度线
          },
        },
        yAxis: {
          name: '（次)',
          type: 'value',
          boundaryGap: false,
          axisLine: {
            show: false, // 隐藏右侧 Y 轴的竖线
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)', // 坐标轴颜色
            }
          },
          axisLabel: {
            color: '#fff', // 坐标字体颜色
          },
          axisTick: {
            show: false, // 去掉轴刻度线
          },
          nameTextStyle: {
            color: '#fff',
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: "solid",
              color: "rgba(255, 255, 255, 0.3)"
            },
            show: true,
          },
        },
        series: [
          {
            type: 'line',
            // smooth: 1,
            lineStyle: {
              color: '#FAC475',
              width: 3
            },
            areaStyle: {
              normal: {
                color: {
                  type: 'linear', // 线性渐变
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {offset: 0, color: 'rgba(255,140,77,1)'}, // 0% 处的颜色
                    {offset: 1, color: 'rgba(255,140,77,0.1)'}  // 100% 处的颜色
                  ],
                  global: false // 使用区域渐变
                }
              }
            },
            data: this.rightMiddleData,
            // data: [['8月','0'],['9月','3'],['10月','1'],['11月','3']],
            itemStyle: {
              // 设置数据点的大小和样式
              color: '#ffffff;', // 数据点颜色
              borderColor: '#fbbb5d',
              borderWidth: 3, // 边框宽度
            },
            symbolSize: function (value) {
              return 10;
            },
          }

        ],
        textStyle: {
          color: '#ececec' // 全局文字颜色
        }
      };
    },
    // 新建透视相机
    setCamera() {
      this.camera = new THREE.PerspectiveCamera(60, this.contant.clientWidth / this.contant.clientHeight, 0.1, 500);
      this.camera.position.z = 1
    },
    // 设置渲染器
    setRenderer() {
      this.renderer = new THREE.WebGLRenderer()
      // 设置画布的大小
      this.renderer.setSize(this.contant.clientWidth, this.contant.clientHeight)
      //这里 其实就是canvas 画布  renderer.domElement
      this.contant.appendChild(this.renderer.domElement)
      this.renderer.setClearColor(0x000000, 0)
    },
    render() {
      this.renderer.render(this.scene, this.camera)
    },
    generateGeometry() {
      // 初始化一个地图对象
      this.map = new THREE.Object3D()
      //Todo 切换省份之后要调整
      // 墨卡托投影转换
      //福建省 几何中心经纬度[119.172526, 26.061405]
      const projection = d3
        .geoMercator()
        .center([118.172526, 26.000000])
        .scale(50)
        .translate([0, 0])
      jsondata.features.forEach((elem) => {
        this.renderer.render(this.scene, this.camera);
        let coordinates = elem.geometry.coordinates[0]
        const cityName = elem.properties.name;
        const cityCode = elem.properties.adcode;
        // 循环坐标数组
        coordinates.map((polygon) => {
          // multiPolygon.forEach((polygon, index) => {
            const province = new THREE.Object3D()
            const shape = new THREE.Shape()
            const pointsArray = []
            for (let i = 0; i < polygon.length; i++) {
              const [x, y] = projection(polygon[i])
              if (i === 0) {
                shape.moveTo(x, -y)
              }
              shape.lineTo(x, -y)
              pointsArray.push(new THREE.Vector3(x, -y, 0.21))
            }
            // 确保闭合
            if (pointsArray.length > 0) {
            pointsArray.push(pointsArray[0]); // 添加回第一个点
            }
            const lineMaterial = new THREE.LineBasicMaterial({
              color: 'white',
            })
            const lineGeometry = new THREE.BufferGeometry()
            lineGeometry.setFromPoints(pointsArray)
            const extrudeSettings = {
              //图形厚度
              depth: 0.2,
              bevelEnabled: false,
            }

            const geometry = new THREE.ExtrudeGeometry(
              shape,
              extrudeSettings
            )
            const material = new THREE.MeshPhongMaterial({
              color: '#ffa011',
              transparent: true,
              opacity:1,
            })
            material.userData.cityName = cityName
            material.userData.cityCode = cityCode
            const material1 = new THREE.MeshBasicMaterial({
              color: '#ffa011',
              transparent: true,
              opacity: 0.4,
            })
            const loader = new FontLoader();
            //字体
            loader.load('static/font/PingFang.json', (font) => {
              const fontOption = {
                font: font,
                size: 0.07,
                height: 0.01,
                curveSegments: 1,
                bevelThickness: 1,
                bevelSize: 0,
                bevelEnabled: false,
                bevelSegments: 0
              };
              const txtMater = new THREE.MeshBasicMaterial({ color: 0xffffff });
              const txtGeometry = new TextGeometry(cityName, fontOption);
              txtGeometry.computeBoundingSphere(); // 计算边界球
              const txtMesh = new THREE.Mesh(txtGeometry, txtMater);
              //Todo 切换省份之后可能得调整
              const [x, y] = projection(elem.properties.center)
              txtMesh.position.set(x-0.2 , -y , 0.2)
              if (cityName === '宁德市') {
                //这里位置不对可以做微调
                txtMesh.position.set(x-0.2, -y + 0.1, 0.2)
              }
              if (cityName === '南平市') {
                //这里位置不对可以做微调
                txtMesh.position.set(x-0.2, -y + 0.2, 0.2)
              }
              if (cityName === '漳州市') {
                //这里位置不对可以做微调
                txtMesh.position.set(x-0.2, -y - 0.2, 0.2)
              }
              this.scene.add(txtMesh);

            });
            const mesh = new THREE.Mesh(geometry, [material, material1])
            const line = new THREE.Line(lineGeometry, lineMaterial)
            province.properties = elem.properties
            this.provinceMeshData.push(mesh)
            province.add(mesh)
            province.add(line)
            this.map.add(province)
          // })
        })
      })
      //地图基座图片svga
      // 创建 Canvas 用于 SVGA 动画
      const canvas = document.createElement('canvas');
      const canvasBox = document.getElementById('canvasBox');
      canvas.width = 850; // 设置适当的宽度
      canvas.height = 850; // 设置适当的高度
      // const canvas = document.getElementById('canvas')
      this.mapBasecontext = canvas.getContext('2d');
      canvasBox.appendChild(canvas)
      this.$nextTick(()=>{
       // 创建 SVGA 动画播放器
       const svgaPlayer = new SVGA.Player(canvas);
       //  const svgaPlayer = new SVGA.Player('#canvas');
       svgaPlayer.loops = this.loops || Number.MAX_SAFE_INTEGER; //循环播放次数
       svgaPlayer.clearsAfterStop = false;
       //创建解析者
       let svgaParser = new SVGA.Parser();
       svgaParser.load('/static/svga/mapBase.svga', (videoItem) => {
         svgaPlayer.setVideoItem(videoItem);
         svgaPlayer.startAnimation();
       }, (error) => {
         console.error('SVGA loading error:', error);
       });
     })
      this.mapBasetexture = new THREE.CanvasTexture(canvas);
      // 创建 SVGA 背景平面
      const svgaMaterial = new THREE.MeshBasicMaterial({ map: this.mapBasetexture, transparent: true });
      const svgaGeometry = new THREE.PlaneGeometry(11, 11);
      const svgaMesh = new THREE.Mesh(svgaGeometry, svgaMaterial);
      svgaMesh.position.z = -0.2;
      this.mapBasetexture.needsUpdate = true
      this.scene.add(svgaMesh);
      let _this = this
      function animate() {
        requestAnimationFrame(animate);
        _this.mapBasetexture.needsUpdate = true; // 更新纹理
        _this.renderer.render(_this.scene, _this.camera);
      }
      animate();

      // const textureLoader = new THREE.TextureLoader();
      // const texture = textureLoader.load('/static/chartlet/fujian.png', () => {
      //     // 纹理加载完成后创建几何体
      //     const geometry = new THREE.PlaneGeometry(2.9, 2.9); // 创建平面几何体
      //     const material = new THREE.MeshBasicMaterial({map: texture,transparent: true}); // 应用纹理材质
      //     const plane = new THREE.Mesh(geometry, material); // 创建网格对象
      //   plane.position.set(0.06,-0.12,0.21)
      //     // 添加到场景
      //     this.map.add(plane);
      //   })
      // this.createCylindern(50)
      this.scene.add(this.map);
      this.scene.position.set(0, 0.5, 0); //场景位置 之后要修改旋转中心
      this.spotLight.target = this.map;
      this.camera.position.set(0, -2.7, 2.5); //相机位置
      this.renderer.render(this.scene, this.camera);

    },
    //计算多边形中心的函数
    getCentroid(points) {
      let xSum = 0;
      let ySum = 0;
      const n = points.length;

      for (const point of points) {
        xSum += point.x;
        ySum += point.y;
      }

      return new THREE.Vector3(xSum / n, ySum / n, 0);
    },
    //加事件
    setClickFn() {
      this.raycaster = new THREE.Raycaster();
      this.mouse = new THREE.Vector2();
      const onMouseMove = (event) => {
        let marginLeft = this.contant.offsetLeft
        let marginTop = this.contant.offsetTop
        // 如果该地图不是占满全屏需要减去margintop和marginleft
        // 将鼠标位置归一化为设备坐标。x 和 y 方向的取值范围是 (-1 to +1)
        // this.mouse.x = (event.clientX / this.contant.clientWidth) * 2 - 1;
        // this.mouse.y = -(event.clientY / this.contant.clientHeight) * 2 + 1;
        this.mouse.x = ((event.clientX - marginLeft) / this.contant.clientWidth) * 2 - 1;
        this.mouse.y = -((event.clientY - marginTop) / this.contant.clientHeight) * 2 + 1;
      };

      let clickPosition;
      window.addEventListener("mousemove", onMouseMove, false);
      const onclick = (event) => {
        let marginLeft = this.contant.offsetLeft
        let marginTop = this.contant.offsetTop
        // let x = (event.clientX / this.contant.clientWidth) * 2 - 1;
        // let y = -(event.clientY / this.contant.clientHeight) * 2 + 1;
        // 如果该地图不是占满全屏需要减去margintop和marginleft
        let x = ((event.clientX - marginLeft) / this.contant.clientWidth) * 2 - 1;
        let y = -((event.clientY - marginTop) / this.contant.clientHeight) * 2 + 1;
        clickPosition = { x: x, y: y };
        this.raycaster.setFromCamera(clickPosition, this.camera);
        // 算出射线 与当场景相交的对象有那些
        let intersects = this.raycaster.intersectObjects(this.provinceMeshData, true);
        if (intersects.length > 0) {
          const selectedObject = intersects[0].object;
          if (selectedObject instanceof THREE.Mesh) {
            let material = null
            if(selectedObject.material instanceof Array){
              material = selectedObject.material.filter(v=>v.isMeshPhongMaterial)[0]
            }else {
              material = selectedObject.material
            }
            if(material.userData.cityCode !== 350500){//泉州
              this.leftTopData={xAxis:[],AlarmyAxis:[],completeyAxis:[]},
                this.leftMiddleData = [],
                this.leftBottomData = [],
                this.rightTopData = {xAxis:[],AlarmyAxis:[],completeyAxis:[]},
                this.rightMiddleData = [],
                this.rightBottomData = [],
                this.planData=[]
                this.flyStatus = []
                this.initCharts()
            }else {
              this.getPageData()
            }
            // material.userData.cityCode

            // 恢复上一个被点击城市的颜色
            if (this.lastClickedObject && this.lastClickedObject !== selectedObject) {
                this.lastClickedObject.material.filter(v=>v.isMeshPhongMaterial)[0].color.set(0xffa011)
            }
            // 设置高亮颜色
            material.color.set(0xff782e); // 设置为红色高亮
            // 更新上一个被点击的对象
            this.lastClickedObject = selectedObject;
          }
        } else {

          }
      }
      this.contant.addEventListener("mousedown", onclick, false);
    },
    // 设置最大旋转的角度
    setController() {
      const controls = new OrbitControls(this.camera, this.renderer.domElement);
      //相机默认为2.5
      // this.scene.position.set(0, 1, 0); //场景位置 之后要修改旋转中心
      // controls.target.set(0, 0.5, 0)//旋转中心
      // controls.update()
      controls.maxPolarAngle = 2.6
      controls.minPolarAngle = 2
      controls.maxAzimuthAngle = 0.2
      controls.minAzimuthAngle = -0.2
      controls.addEventListener("change", () => {
        this.renderer.render(this.scene, this.camera);
      });
    },
    createCylindern(num){
      //创建粒子数组
      const particleCount = num;
      const particleGeometry = new THREE.SphereGeometry(0.02); // 球形粒子几何体
      // const particleMaterial = new THREE.MeshBasicMaterial({ color: 0x43A7FF });
      const particleMaterial = new THREE.ShaderMaterial({
        uniforms: {
          color1: { value: new THREE.Color(0xffa011) },
          color2: { value: new THREE.Color(0xff782e) }
        },
        vertexShader: `
            varying float vAlpha;
            void main() {
                vAlpha = (position.z+1.0)*0.45;  // 使用 z 位置作为 alpha 值
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                gl_PointSize = 10.0;  // 控制点大小
            }
        `,
        fragmentShader: `
            varying float vAlpha;
            uniform vec3 color1;
            uniform vec3 color2;
            void main() {
                vec3 color = mix(color1, color2, vAlpha * 0.5 + 0.1); // 颜色渐变
                gl_FragColor = vec4(color, 1.0); // 设定为不透明
            }
        `,
        transparent: true
      });
      for (let i = 0; i < particleCount; i++) {
        const particle = new THREE.Mesh(particleGeometry, particleMaterial);
        // 随机位置
        let randomArr =  this.getRandomCoordinate()
        if(randomArr){
          particle.position.set(...randomArr);
          this.particles.push(particle);
          this.scene.add(particle);
        }
      }
    },
    animate() {
      window.requestAnimationFrame(this.animate);
      this.raycaster.setFromCamera(this.mouse, this.camera);
      // 使粒子上升
      // this.particles.forEach(particle => {
      //   particle.position.z += 0.001 + Math.random() * (0.005 - 0.001); // 向上移动
      //   // particle.scale.x += 0.001; // 增加 X 轴缩放
      //   // particle.scale.y += 0.001; // 增加 Y 轴缩放
      //   // particle.scale.z += 0.001; // 增加 Z 轴缩放
      //   // 逐渐变淡
      //   particle.material.opacity -= 0.01;
      //   if (particle.material.opacity < 0) {
      //     particle.material.opacity = 0; // 确保不小于 0
      //   }
      //   // 改变颜色
      //   const colorChange = Math.floor(255 * (1 - particle.material.opacity));
      //   // particle.material.color.setRGB(0.25, 0.5, 1 - colorChange / 255); // 渐变效果
      //   // 当粒子超出屏幕高度时重置位置和缩放
      //   if (particle.position.z > 1) {
      //     this.scene.remove(particle);
      //     let randomArr = this.getRandomCoordinate(1)
      //     if(randomArr){
      //       particle.position.z=-1
      //       particle.position.x = randomArr[0]
      //       particle.position.y = randomArr[1]
      //       particle.scale.set(1, 1, 1); // 重置缩放
      //       particle.material.opacity = 1; // 重置透明度
      //       this.scene.add(particle);
      //       // particle.material.color.setRGB(0.25, 0.5, 1); // 重置颜色
      //     }
      //   }
      // });
      // 更新 Canvas
      // this.mapBasetexture.needsUpdate = true; // 告诉纹理需要更新
      this.renderer.render(this.scene, this.camera);
    },
    getRandomCoordinate(){
      let x = (Math.random()-0.5) * 10
      let y = (Math.random()-0.5) * 10
      let z = 0
      this.raycaster = new THREE.Raycaster();
      this.raycaster.setFromCamera({ x: x, y: y }, this.camera);
      // 算出射线与地图是否相交
      let intersects = this.raycaster.intersectObjects(this.provinceMeshData,
        true);
      if (intersects.length > 0) {
        this.getRandomCoordinate()
      }else {
        return [x,y,z]
      }
    },
    filterPlanData(key){
      if(this.planData.length){
       return  this.planData.filter(v=> v[0] === key)[0][1]
      }else {
        return '暂无'
      }
    },
    //销毁three
    disposeScene() {
      cancelAnimationFrame(this.animate)
      // 从DOM中删除渲染器(canvas)元素
      this.renderer.domElement.remove();
      // 销毁场景内的所有网格、材质和纹理等物体
      this.scene.traverse(function(obj) {
        if (obj instanceof THREE.Mesh) {
          obj.geometry.dispose();
          if(obj.material instanceof Array){
            obj.material.map(v=>{
              v.dispose();
            })
          }else {
            obj.material.dispose();
          }
        }
        if (obj instanceof THREE.Texture) {
          obj.dispose();
        }
      });
      // 将场景中的所有物体从场景中移除并将其设置为null
      while (this.scene.children.length > 0) {
        this.scene.remove(this.scene.children[0]);
      }
      // 销毁渲染器、相机和控制器等对象并将其设置为null
      this.renderer.dispose();
      this.controls = null;
      // 停止动画
    },
    handleResize() {
      this.leftTop.resize();
      this.rightTop.resize();
      this.rightMiddle.resize();
    },
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'PangMenZhengDao-3';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

@font-face {
  font-family: 'PangMenZhengDao-3-Regular';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

@font-face {
  font-family: 'PangMenZhengDao';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf) ;
}

* {
  box-sizing: border-box;

}
#canvasBox{
  width: 0;
  height: 0;
  position: absolute;
  overflow: hidden;
}

.page {
  background-image: url("../../assets/img/statistic/bg.png");
  padding: 12px 20px 21px 20px;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  flex: 1;
  justify-content: space-between;
}

.left-container,
.right-container {
  background: rgba(23, 11, 1, 0.30);
  width: 415px;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.middle-container {
  display: flex;
  flex: 1022;
}

.contentWrap {
  z-index: 1;
  flex :317;
  //height: 317px;
  width: 408px;
  display: flex;
  flex-direction: column;
}
.rankWrap  >>>.el-carousel__arrow,
.rankWrap  >>>.el-carousel__indicators{
  display: none;
}
.rankWrap  >>>.el-carousel,
.rankWrap  >>>.el-carousel__container {
  height: 100% !important;
}
.rankWrap  >>>.el-carousel__item{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.title {
  width: 408px;
  line-height: 50px;
  background-image: url("../../assets/img/statistic/pop_bg.png");
  background-repeat: no-repeat;
  padding-left: 13px;
  font-family: PangMenZhengDao, PangMenZhengDao-3;
  font-weight: 200;
  font-style: italic;
  text-align: left;
  color: #ffffff;
  text-shadow: -2px 0 3.68px 0.16px rgba(16, 1, 0, 0.50);
  font-size: 26px;
}

.chartWrap {
  width: 100%;
  //height: 252px;
  flex: 252;
  background: rgba(0, 0, 0, 0.50);
  border-radius: 6px;
  margin-top: 2px;
}
.operatorRankWrap >>>.el-carousel__container .el-carousel__arrow{
  display: none;
}
.operatorRankWrap  >>>.el-carousel__item{
  width: 100%;
  flex:252;
  padding: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.operatorRankWrap  >>>.el-carousel__indicators{
  display: none;
}

.operatorRankItem{
  width: 380px;
  height: 32px;
  background-image: url("../../assets/img/statistic/data_bg_1.png");
  display: flex;
  align-items: center;
}
.operatorName{
  margin-left: 20px;
  width:75px;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ececec;
}
.progressBar{
  width: 235px;
  height: 8px;
}
.figure{
  margin-left: 8px;
  font-size: 14px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: right;
  color: #ececec;
}
.rankWrap{
  width: 100%;
  flex: 252;
  padding: 16px 8px 14px 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.rankItem{
  width: 392px;
  height: 22px;
  background-image: url("../../assets/img/statistic/data_bg_2.png");
  display: flex;
  align-items: center;
}
.bottomName{
  margin-left: 12px;
  width: 82px;
  height: 22px;
  margin-right: 16px;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #ffffff;
  background-repeat: no-repeat;
  background-size: 100% auto;
}
.firstName{
  background-image: url("../../assets/img/statistic/pai_ming_1.png");
}
.secondName{
  background-image: url("../../assets/img/statistic/pai_ming_2.png");
}
.thirdName{
  background-image: url("../../assets/img/statistic/pai_ming_3.png");
}
.otherName{
  background-image: url("../../assets/img/statistic/pai_ming_other.png");
}
.middle-container{
  padding: 0 20px 0 20px;
  display: flex;
  flex-direction: column;
}
.middleTop{
  display: flex;
  justify-content: space-between;
}
.middleTopItem{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 230px;
  height: 68px;
  padding: 24px 45px 24px 45px;
}
.middleTopItem .itemContent{
  width: 200px;
  height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.heifei{
  background-image: url("../../assets/img/statistic/data_line_red.png");
}
.chongtu{
  background-image: url("../../assets/img/statistic/data_line_orange.png");
}
.pianhang{
  background-image: url("../../assets/img/statistic/data_line_yellow.png");
}
.zhengchang{
  background-image: url("../../assets/img/statistic/data_line_green.png");
}
.heifei .itemValue{
  color: #ff5555;
}
.chongtu .itemValue{
  color: #ff8c4d;
}
.pianhang .itemValue{
  color: #ffc877;
}
.zhengchang .itemValue{
  color: #25d875;
}

.middleTopItem .itemContent .itemTitle{
  font-size: 18px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  font-style: italic;
  text-align: left;
  color: #ffffff;
}
.middleTopItem .itemContent .itemValue{
  font-size: 28px;
  font-family: PangMenZhengDao, PangMenZhengDao-3;
  font-weight: 200;
  font-style: italic;
  //text-align: left;
  text-shadow: -2px 0px 3.68px 0.16px rgba(16,1,0,0.50);
}
.middleBottom{
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}
.middleChart{
  flex: 1010;
  width: 100%;
  //height: 680px;
  //width: 1010px;
}
.middleBottom .bottomItem{
  display: flex;
  justify-content: center;
  position: relative;
  width: 200px;
  height: 200px;
}
.bottomItemContent{
  position: absolute;
  top:39px;
  width: 92px;
  height: 88px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bottomItemContent span{
  display: block;
}
.bottomItemContent .key{
    z-index: 1;
    font-size: 17px;
    font-family: Adobe Heiti Std, Adobe Heiti Std-R;
    font-weight: normal;
    text-align: left;
    color: #ffffff;
}
.bottomItemContent .value{
  margin-bottom: 20px;
  font-size: 28px;
  font-family: PangMenZhengDao, PangMenZhengDao-3;
  font-weight: 200;
  font-style: italic;
  text-align: left;
  color: #ffffff;
  text-shadow: -2px 0px 3.68px 0.16px rgba(16,1,0,0.50);
}
canvas {
  image-rendering: crisp-edges; /* 对于 Firefox */
  image-rendering: pixelated; /* 其他浏览器 */
}
</style>



// WEBPACK FOOTER //
// src/components/home/FlightStatistics.vue